















import { createComponent } from "@vue/composition-api";
import ListUnitTable from "@/components/ListUnitTable.vue";
import { ZastosowanieCategoryAttribute } from "@megarax/client/src/resources/plm";
import AttributeForm from "./AttributeForm.vue";

interface Props {
  value: ZastosowanieCategoryAttribute[];
  editable: boolean;
}

export default createComponent<Props>({
  components: {
    ListUnitTable,
  },
  props: {
    value: { required: true, type: Array },
    editable: { type: Boolean },
  },
  setup(props, ctx) {
    return {
      AttributeForm,
      unitFactory: () => new ZastosowanieCategoryAttribute(),
    };
  },
});
